export default __webpack_public_path__ + "static/media/goat.2365a333.png";